export const LibraryFromInsert = {
  flow: 'y',
  gap: 'Z',
  CaptionTitle: {
    align: 'center',
    Text: {
      text: '{{ editor.insert.fromLibrary | polyglot }}'
    },
    SearchButton: {
      extends: ['CanvasButton', 'IconButton'],
      icon: 'search',
      ariaLabel: (el) => el.call('polyglot', 'editor.insert.searchLibrary'),
      margin: '- auto - A'
    },
    ExpandButton: {
      extends: ['CanvasButton', 'IconButton'],
      icon: 'expand',
      ariaLabel: (el) => el.call('polyglot', 'editor.insert.expandLibrary'),
      onClick: (ev, el) => {
        el.setWindow('explorer', 'insert:library')
      }
    },
    width: '100%'
  }
}
